document.querySelectorAll('[data-targetit]').forEach(element => {
  element.addEventListener('click', function(e) {
    this.classList.add('current');
    Array.from(this.parentNode.children).forEach(sibling => {
      if (sibling !== this) sibling.classList.remove('current');
    });

    const target = this.getAttribute('data-targetit');
    document.querySelectorAll(`[class^="boxMainTabs-"]`).forEach(tab => {
      tab.style.display = 'none';
    });

    const targetElement = document.querySelector(`.${target}`);
    targetElement.style.display = 'block';
    fadeIn(targetElement);
    var $carousel = $('.' + target).find('.carousel').flickity();
    $carousel.show().flickity('resize');
   });
});

// Custom fadeIn function (since vanilla JS doesn't have a built-in fadeIn)
function fadeIn(element) {
  let opacity = 0;
  element.style.opacity = opacity;
  element.style.display = 'block';

  const fadeEffect = setInterval(() => {
    if (opacity < 1) {
      opacity += 0.1;
      element.style.opacity = opacity;
    } else {
      clearInterval(fadeEffect);
    }
  }, 50);
}

$(document).ready(function () {
  // Open submenu on click
  $('.dropdown-toggle').on('click', function (e) {
    e.preventDefault(); // Prevent default link behavior
    const target = $(this).data('target');
    $(target).addClass('active'); // Show the submenu
  });

  // Go Back button functionality
  $('.go_back').on('click', function () {
    $(this).closest('.sub_menu_slide').removeClass('active'); // Hide the submenu
  });
  window.addEventListener('scroll', function() {
        console.log("sticky is working fine!");
        var scroll = window.scrollY; // Get the vertical scroll position

        var header = document.querySelector('.main-tabs-list-rad');
        if (header) {
            if (scroll >= 800) {
                header.classList.add('fixed');
                // $(".main-tabs-list-rad").css("top", "0")
            } else {
                header.classList.remove('fixed');
                // $(".main-tabs-list-rad").css("top", "79px")
            }
        }
    });
  function checkMobileView() {
      if (window.matchMedia("(max-width: 768px)").matches) {
          // $(".main-tabs-list-rad").addClass("fixed");
      } else {
          // $(".main-tabs-list-rad").removeClass("fixed");
      }
    }
    checkMobileView();
    $(window).resize(function () {
        checkMobileView();
    });
});